module.exports = __webpack_public_path__ + "static/chattova-dffed86141ed5ec3ffa91380595a7805.jpg";